/**
 * Zoom Meeting SDK settings that are safe to ship.
 *
 * The KEY and SECRET are no longer here — they come from the backend at join
 * time (GET zoom/sdk/credentials/, AES-encrypted, see ZoomCredentialsService),
 * so nothing sensitive is compiled into the bundle.
 */

/** Zoom enforces a minimum supported version — bump as it nears end of support. */
export const ZOOM_SDK_VERSION = "6.2.0";

/**
 * Backend route returning { signature }. Empty means the browser signs locally
 * with the credentials fetched above. Setting it retires browser-side signing
 * entirely, which is still the better end state.
 */
export const ZOOM_SIGNATURE_ENDPOINT = "";
